import { render, staticRenderFns } from "./OrgSaasTaxDocuments.vue?vue&type=template&id=45d9b57c"
import script from "./OrgSaasTaxDocuments.vue?vue&type=script&lang=js"
export * from "./OrgSaasTaxDocuments.vue?vue&type=script&lang=js"
import style0 from "./OrgSaasTaxDocuments.vue?vue&type=style&index=0&id=45d9b57c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports